/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
// @ts-nocheck
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
// material
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  Typography,
  FormHelperText,
  Grid,
  FormControlLabel,
  Checkbox,
  Divider,
  Tooltip,
  Paper,
  List,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
// utils & redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import connectSaga from 'utils/saga';
import { actionProps, selectState } from 'utils/reduxActions';
import { receiptsActions } from 'screens/Receipts/reducer';
import { appActions } from 'commons/reducer';
import { getUnitDetails, truthty, falsy, onChangeFnc, clone } from 'utils/functions';
import { isBulkPackagingType } from 'utils/packagingTypeBehavior';
import {
  shouldPrintFourAutomationLabelsPerPak,
  shouldShowIncomingDeliveryReference,
} from 'utils/tenantFeatures';
// components
import saga from '../../saga';
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';
import DatePicker from '../../../../commons/components/DatePicker';
import LotListItem from '../../../Returns/components/LotListItem';
import WeightField from '../../../../commons/containers/WeightField';
// automation
import { useAutomation } from 'utils/hooks/useAutomationPermission';
import CustomFieldsSection from '../CustomFieldsSection';

function ReceiptForm(props) {
  const {
    actions,
    toggleForm,
    device,
    formIsOpen: isOpen,
    edit,
    formControls: stateControls,
    invalidControls,
    objects,
    toEditId,
    classes,
    lastLotNumber,
    addToReturnLots,
    printLotFnc,
    toggleDeleteLot,
    permissions,
  } = props;

  const { t } = useTranslation();
  const { unitCode } = getUnitDetails(objects.accounts);
  const customFieldsRef = useRef();

  const [controls, setControls] = useState({ ...stateControls });
  const [customFieldsDraft, setCustomFieldsDraft] = useState({
    deliveryType: '',
    supplierName: '',
    callOff: '',
    incomingDeliveryReference: '',
    plateNumber: '',
  });

  // Permisos
  const { hasAutomation } = useAutomation();
  const canUseAlphanumeric = permissions?.includes('alphanumeric_lot_number');
  const canUseAlphanumericShippingGuide = permissions?.includes('alphanumeric_shipping_guide');
  useEffect(() => {
    setControls({ ...stateControls });
    setCustomFieldsDraft({
      deliveryType: stateControls.deliveryType || '',
      supplierName: stateControls.supplierName || '',
      callOff: stateControls.callOff || '',
      incomingDeliveryReference: stateControls.incomingDeliveryReference || '',
      plateNumber: stateControls.plateNumber || '',
    });
  }, [stateControls]);

  const newLotNumber = canUseAlphanumeric
    ? controls.lotNumber || ''
    : controls.lotNumber || Number(lastLotNumber) + 1;

  const settingControls = (changes) => {
    setControls({ ...controls, ...changes });
  };

  const settingPaddockValues = (changes) => {
    const paddock = objects.paddocks[changes.paddockId];
    setControls({
      ...controls,
      paddockId: paddock?.id,
      fruitId: paddock?.fruit().id || '',
      varietyId: paddock?.variety().id || '',
      productId: paddock?.product().id || '',
      ...changes,
    });
  };

  const changeControls = (event, date) => {
    onChangeFnc(settingControls, event, date);
  };

  const changeWeight = (weight) => {
    actions.changeControls({ ...controls, quantity: weight }, { quantity: false });
  };

  const changePaddock = (event) => {
    onChangeFnc(settingPaddockValues, event);
  };

  const hasLotsInAnotherProcess = useMemo(() => {
    if (!hasAutomation || !controls.receiptId || !objects.receipts?.[controls.receiptId]) return false;
    const receiptLots = objects.receipts[controls.receiptId].lots?.() || [];
    return receiptLots.some((lot) => Boolean(lot.destinyProcessId));
  }, [hasAutomation, controls.receiptId, objects.receipts]);
  const canApplyAutomationReclassification = hasAutomation && hasLotsInAnotherProcess;
  const isAutomationFlow = hasAutomation && Boolean(controls.receiptId);
  const shouldRenderAutomationCustomFields =
    hasAutomation &&
    (Boolean(controls.receiptId) || shouldShowIncomingDeliveryReference());
  const packagingReadOnly = canApplyAutomationReclassification;

  const handleCustomFieldsChange = (nextCustomFields) => {
    setCustomFieldsDraft(nextCustomFields);
    setControls((prev) => ({
      ...prev,
      ...nextCustomFields,
    }));
  };

  const hasReclassificationChanges = useMemo(() => {
    if (!canApplyAutomationReclassification) return false;

    const normalize = (value) => (value === null || value === undefined ? '' : `${value}`);
    const sourceCustom = {
      deliveryType: stateControls.deliveryType || '',
      supplierName: stateControls.supplierName || '',
      callOff: stateControls.callOff || '',
      incomingDeliveryReference: stateControls.incomingDeliveryReference || '',
      plateNumber: stateControls.plateNumber || '',
    };

    const controlsChanged =
      normalize(controls.fruitId) !== normalize(stateControls.fruitId) ||
      normalize(controls.varietyId) !== normalize(stateControls.varietyId) ||
      normalize(controls.productId) !== normalize(stateControls.productId) ||
      normalize(controls.warehouseId) !== normalize(stateControls.warehouseId) ||
      normalize(controls.supplierId) !== normalize(stateControls.supplierId) ||
      normalize(controls.clientId) !== normalize(stateControls.clientId) ||
      normalize(controls.harvester) !== normalize(stateControls.harvester) ||
      normalize(controls.paddockId) !== normalize(stateControls.paddockId) ||
      normalize(controls.price) !== normalize(stateControls.price);

    const customChanged =
      normalize(customFieldsDraft.deliveryType) !== normalize(sourceCustom.deliveryType) ||
      normalize(customFieldsDraft.supplierName) !== normalize(sourceCustom.supplierName) ||
      normalize(customFieldsDraft.callOff) !== normalize(sourceCustom.callOff) ||
      normalize(customFieldsDraft.incomingDeliveryReference)
        !== normalize(sourceCustom.incomingDeliveryReference) ||
      normalize(customFieldsDraft.plateNumber) !== normalize(sourceCustom.plateNumber);

    return controlsChanged || customChanged;
  }, [canApplyAutomationReclassification, controls, stateControls, customFieldsDraft]);

  const getVarietiesById = (varietyId) => {
    const variety = Object.values(objects.varieties).find((variety) => variety.id === varietyId);
    return variety || null;
  };

  let varietiesOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.varieties || {}) // 1. Validamos que el objeto exista
        .filter((v) => v && v.name) // 2. Filtramos elementos nulos o sin nombre
        .sort((a, b) => {
          // 3. Usamos localeCompare para evitar errores de tipo
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        }),
    ],
    [objects.varieties],
  );

  const productsOptions = useMemo(
    () =>
      Object.values(objects.products || {})
        .filter((product) => product && product.name)
        .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
    [objects.products],
  );

  const productsOptionsFiltered = useMemo(() => {
    const productsWithMatchingVariety = controls.varietyId
      ? productsOptions.filter((product) => product.varietyId === controls.varietyId)
      : productsOptions.filter((product) =>
          varietiesOptions.some((variety) => variety?.id === product.varietyId),
        );

    const productsWithoutVariety = productsOptions.filter((product) => !product.varietyId);

    return [...productsWithMatchingVariety, ...productsWithoutVariety];
  }, [controls.varietyId, productsOptions, varietiesOptions]);

  const suppliersOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.suppliers).sort((a, b) =>
        a.entity().name.toLowerCase() > b.entity().name.toLowerCase() ? 1 : -1,
      ),
    ],
    [objects.suppliers],
  );

  const clientsOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.clients || {})
        .filter((client) => client && client.isInternalClient)
        .sort((a, b) => {
          const nameA = a.entity?.()?.name?.toLowerCase() || '';
          const nameB = b.entity?.()?.name?.toLowerCase() || '';
          return nameA.localeCompare(nameB);
        }),
    ],
    [objects.clients],
  );

  const packagingTypesOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.packagingTypes).sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      ),
    ],
    [objects.packagingTypes],
  );
  const selectedPackagingType = controls.packagingTypeId
    ? objects.packagingTypes?.[controls.packagingTypeId]
    : null;
  const usesBulkPackaging = useMemo(
    () => isBulkPackagingType(selectedPackagingType),
    [selectedPackagingType],
  );

  useEffect(() => {
    if (usesBulkPackaging && controls.multipleLots) {
      setControls((prev) => ({
        ...prev,
        multipleLots: false,
      }));
    }
  }, [usesBulkPackaging, controls.multipleLots]);

  useEffect(() => {
    if (!controls.receiptId && isOpen) {
      const defaultClient = clientsOptions.find((client) => client.isDefaultClient);
      if (defaultClient) {
        const e = {
          autocomplete: true,
          input: 'clientId',
          value: defaultClient ? defaultClient.id : '',
        };
        changeControls(e);
      }
    }
  }, [isOpen]);

  const fruitsOptions = useMemo(
    () => [
      '',
      ...Object.values(objects.fruits).sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
      ),
    ],
    [objects.fruits],
  );

  const submit = (lotNumber, totalWeight) => {
    if (
      falsy(lotNumber) ||
      falsy(controls.supplierId) ||
      falsy(controls.paddockId) ||
      falsy(controls.price)
    ) {
      actions.setInvalidControls({
        lotNumber: falsy(lotNumber),
        supplierId: falsy(controls.supplierId),
        paddockId: falsy(controls.paddockId),
        price: falsy(controls.price),
      });
    } else if (edit) {
      actions.editReceipt(toEditId, controls, totalWeight);
    } else {
      actions.changeControls(controls, invalidControls);
      const receipt = { ...controls, lotNumber };
      actions.createReceipt(receipt);
    }
  };

  const buildLotsToAdd = () => {
    const { quantity, packagingTypeId, packagingQuantity, hasPallet } = controls;
    let totalWeight = 0;
    if (truthty(quantity) && truthty(packagingTypeId) && truthty(packagingQuantity)) {
      const palletWeight = (hasPallet && objects.packagingTypes[packagingTypeId].palletWeight) || 0;
      const toDiscountWeight = objects.packagingTypes[packagingTypeId].weight + palletWeight;
      totalWeight = quantity - toDiscountWeight * packagingQuantity;
    }

    if (
      falsy(controls.fruitId) ||
      falsy(controls.varietyId) ||
      falsy(controls.productId) ||
      falsy(controls.packagingTypeId) ||
      falsy(controls.quantity) ||
      falsy(controls.packagingQuantity) ||
      totalWeight <= 0
    ) {
      actions.setInvalidControls({
        fruitId: falsy(controls.fruitId),
        varietyId: falsy(controls.varietyId),
        productId: falsy(controls.productId),
        packagingTypeId: falsy(controls.packagingTypeId),
        quantity: falsy(controls.quantity),
        packagingQuantity: falsy(controls.packagingQuantity),
      });
      return null;
    }

    const toAddLot = {
      receiptId: controls.receiptId,
      fruitId: controls.fruitId,
      varietyId: controls.varietyId,
      productId: controls.productId,
      packagingTypeId: controls.packagingTypeId,
      packagingQuantity: controls.packagingQuantity,
      quantity: totalWeight,
      warehouseId: controls.warehouseId !== '' ? controls.warehouseId : null,
      customField: controls.customField || '',
      datetime: moment().toISOString(),
    };
    const toAddLots = [];
    while (toAddLots.length < (controls.multipleLots ? controls.packagingQuantity : 1)) {
      toAddLots.push({
        ...toAddLot,
        packagingQuantity: controls.multipleLots ? 1 : controls.packagingQuantity,
        quantity: controls.multipleLots ? totalWeight / controls.packagingQuantity : totalWeight,
      });
    }

    return toAddLots;
  };

  const addManualLot = () => {
    const toAddLots = buildLotsToAdd();
    if (!toAddLots) return;

    actions.createReceiptLots(controls.receiptId, toAddLots, device, true);
  };

  const updateManualReceipt = (receiptId) => {
    if (
      falsy(newLotNumber) ||
      falsy(controls.supplierId) ||
      falsy(controls.paddockId) ||
      falsy(controls.price)
    ) {
      actions.setInvalidControls({
        lotNumber: falsy(newLotNumber),
        supplierId: falsy(controls.supplierId),
        paddockId: falsy(controls.paddockId),
        price: falsy(controls.price),
      });
    } else {
      actions.editReceiptData(receiptId, { ...controls });
    }
  };

  const updateAutomationReceipt = (receiptId) => {
    if (
      falsy(newLotNumber) ||
      falsy(controls.supplierId) ||
      falsy(controls.paddockId) ||
      falsy(controls.price)
    ) {
      actions.setInvalidControls({
        lotNumber: falsy(newLotNumber),
        supplierId: falsy(controls.supplierId),
        paddockId: falsy(controls.paddockId),
        price: falsy(controls.price),
      });
    } else {
      const accountId = Object.values(objects.accounts || {})[0]?.id;
      const isCallOffValid = customFieldsRef.current?.validate?.() ?? true;
      if (!isCallOffValid) {
        actions.setInvalidControls({ callOff: true });
        return;
      }
      actions.setInvalidControls({ callOff: false });
      const customFieldsInput = customFieldsRef.current?.getValues() || {};
      const payload = {
        ...controls,
        accountId,
        customFields: {
          ...(controls.customFields || {}),
          deliveryType: customFieldsInput.deliveryType || '',
          supplierName: customFieldsInput.supplierName || '',
          callOff: customFieldsInput.callOff || '',
          incomingDeliveryReference:
            customFieldsInput.incomingDeliveryReference || '',
          plateNumber: customFieldsInput.plateNumber || '',
        },
      };
      actions.editReceiptData(receiptId, payload);
    }
  };

  const handleAutomationFlowAction = () => {
    updateAutomationReceipt(toEditId || controls.receiptId);
  };

  const handleManualFlowAction = () => {
    addManualLot();
  };

  let totalWeight = 0;
  const { quantity, packagingTypeId, packagingQuantity, hasPallet } = controls;

  if (truthty(quantity) && truthty(packagingTypeId) && truthty(packagingQuantity)) {
    const palletWeight = (hasPallet && objects.packagingTypes[packagingTypeId].palletWeight) || 0;
    const toDiscountWeight = objects.packagingTypes[packagingTypeId].weight + palletWeight;
    totalWeight = quantity - toDiscountWeight * packagingQuantity;
  }

  return (
    <Dialog fullWidth onClose={toggleForm} maxWidth="lg" open={isOpen}>
      <DialogTitle>
        {`${edit ? t('receipts.form.editTitle') : t('receipts.form.createTitle')}`}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography gutterBottom variant="h6" component="h6">
              {t('receipts.form.receiptData')}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DatePicker
              inputId="date"
              label={t('receipts.form.date')}
              fullWidth
              value={controls.date}
              onChange={changeControls}
              disabled={Boolean(controls.receiptId)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <DatePicker
              inputId="harvestDate"
              label={t('receipts.filters.harvestDate')}
              fullWidth
              value={controls.harvestDate}
              onChange={changeControls}
              disabled={Boolean(controls.receiptId)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              value={newLotNumber}
              onChange={changeControls}
              fullWidth
              id="lotNumber"
              label={t('receipts.form.lotNumber')}
              error={invalidControls.lotNumber}
              helperText={invalidControls.lotNumber && t('receipts.form.errors.lotNumber')}
              disabled={Boolean(controls.receiptId)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              value={
                controls.supplierId && suppliersOptions.find((s) => s.id === controls.supplierId)
              }
              id="autocomplete-suppliers-filters-receipts"
              options={suppliersOptions}
              getOptionLabel={(supplier) => supplier?.entity?.()?.name || ''}
              renderInput={(params) => (
                <TextField
                  style={{ margin: 0 }}
                  error={truthty(invalidControls.supplierId)}
                  {...params}
                  label={t('receipts.headers.supplier')}
                  margin="normal"
                />
              )}
              onChange={(event, newValue) => {
                const e = {
                  autocomplete: true,
                  input: 'supplierId',
                  value: newValue ? newValue.id : '',
                };
                changeControls(e);
              }}
            />
            {truthty(invalidControls.supplierId) && (
              <FormHelperText error>{t('receipts.form.errors.supplier')}</FormHelperText>
            )}
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Autocomplete
              value={controls.clientId && clientsOptions.find((c) => c.id === controls.clientId)}
              id="autocomplete-clients-filters-receipts"
              options={clientsOptions}
              getOptionLabel={(client) => (client ? client?.entity()?.name : '')}
              renderInput={(params) => (
                <TextField
                  style={{ margin: 0 }}
                  {...params}
                  label={t('receipts.headers.internalClient')}
                  margin="normal"
                />
              )}
              onChange={(event, newValue) => {
                const e = {
                  autocomplete: true,
                  input: 'clientId',
                  value: newValue ? newValue.id : '',
                };
                changeControls(e);
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              value={controls.harvester}
              onChange={changeControls}
              fullWidth
              id="harvester"
              label={t('receipts.headers.harvester')}
              error={invalidControls.harvester}
              helperText={invalidControls.harvester && t('receipts.form.errors.harvester')}
            />
          </Grid>
          {!(hasAutomation && controls.receiptId) && (
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                value={controls.dispatchOrderNumber}
                onChange={(event) => {
                  const { value } = event.target;
                  if (!canUseAlphanumericShippingGuide && value && !/^\d+$/.test(value)) {
                    return;
                  }
                  changeControls(event);
                }}
                fullWidth
                id="dispatchOrderNumber"
                label={t('receipts.filters.dispatchGuide')}
                error={invalidControls.dispatchOrderNumber}
                helperText={
                  invalidControls.dispatchOrderNumber &&
                  t('receipts.form.errors.dispatchOrderNumber')
                }
              />
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <InputLabel id="paddock-label">{t('receipts.headers.paddock')}</InputLabel>
              <Select
                labelId="paddock-label"
                fullWidth
                value={controls.paddockId}
                onChange={changePaddock}
                error={invalidControls.paddockId}>
                <MenuItem id="paddockId" value="">
                  {t('receipts.form.none')}
                </MenuItem>
                {Object.values(objects.paddocks)
                  .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                  .map((paddock) => (
                    <MenuItem
                      key={`paddock-option-${paddock.id}`}
                      id="paddockId"
                      value={paddock.id}>
                      {paddock.name}
                    </MenuItem>
                  ))}
              </Select>
              {truthty(invalidControls.paddockId) && (
                <FormHelperText error>{t('receipts.form.errors.paddock')}</FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              value={controls.price}
              onChange={changeControls}
              fullWidth
              id="price"
              label={t('receipts.form.pricePer', { unit: unitCode })}
              error={invalidControls.price}
              helperText={
                invalidControls.price && t('receipts.form.errors.quantity', { unit: unitCode })
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              value={controls.customField}
              onChange={changeControls}
              fullWidth
              id="customField"
              label={t('process.customField')}
            />
          </Grid>

          {/* Sección de automatización: Custom Fields */}
          {shouldRenderAutomationCustomFields && (
            <CustomFieldsSection
              ref={customFieldsRef}
              onChange={handleCustomFieldsChange}
              initialValues={{
                deliveryType: controls.deliveryType,
                supplierName: controls.supplierName,
                callOff: controls.callOff,
                incomingDeliveryReference: controls.incomingDeliveryReference,
                plateNumber: controls.plateNumber,
              }}
              suppliers={objects.suppliers}
            />
          )}

          {controls.receiptId && (
            <>
              <Grid item container justifyContent="flex-end">
                <Grid item xs={12} sm={6} md={4}>
                  <ButtonWithLoader
                    onClick={() =>
                      isAutomationFlow
                        ? updateAutomationReceipt(toEditId || controls.receiptId)
                        : updateManualReceipt(toEditId || controls.receiptId)
                    }
                    color="primary"
                    variant="outlined"
                    fullWidth
                    autoFocus
                    buttonId="create-edit-receipt-data"
                    disabled={canApplyAutomationReclassification && !hasReclassificationChanges}>
                    {canApplyAutomationReclassification
                      ? 'APLICAR CAMBIOS'
                      : t('receipts.form.update')}
                  </ButtonWithLoader>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography gutterBottom variant="h6" component="h6">
                  {t('receipts.form.pakData')}
                </Typography>
              </Grid>
              <Grid container item justifyContent="flex-start">
                <Grid item xs={12} sm={4} md={3}>
                  <Tooltip title={t('receipts.form.printLabelPerContainer')}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={controls.multipleLots}
                          onChange={changeControls}
                          id="multipleLots"
                          disabled={packagingReadOnly || usesBulkPackaging}
                        />
                      }
                      label={t('receipts.form.separatePaks')}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12} sm={4} md={2}>
                  <Tooltip title={t('receipts.form.addPalletWeight')}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={controls.hasPallet}
                          onChange={changeControls}
                          id="hasPallet"
                          disabled={packagingReadOnly}
                        />
                      }
                      label={t('receipts.form.hasPallet')}
                    />
                  </Tooltip>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography gutterBottom variant="h6" component="h6">
                  {t('receipts.form.product')}
                </Typography>
                <div>
                  <Autocomplete
                    value={
                      controls.productId
                        ? productsOptions.find((p) => p.id === controls.productId) || null
                        : null
                    }
                    id="autocomplete-product-code"
                    options={productsOptions.filter((product) => product.code)}
                    getOptionLabel={(product) => product?.code || ''}
                    renderInput={(params) => (
                      <TextField
                        style={{ margin: 0 }}
                        {...params}
                        label={t('receipts.form.code')}
                        margin="normal"
                      />
                    )}
                    onChange={(event, newValue) => {
                      if (newValue && newValue?.varietyId) {
                        const selectedVariety = getVarietiesById(newValue.varietyId);
                        setControls({
                          ...controls,
                          fruitId: selectedVariety ? selectedVariety.fruitId : '',
                          varietyId: selectedVariety ? selectedVariety.id : '',
                          productId: newValue ? newValue.id : '',
                        });
                      } else if (newValue && newValue?.id) {
                        setControls({
                          ...controls,
                          productId: newValue ? newValue?.id : '',
                        });
                      }
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  value={
                    controls.fruitId && fruitsOptions.find((fruit) => fruit.id === controls.fruitId)
                  }
                  id="autocomplete-fruit-receipts"
                  options={fruitsOptions}
                  getOptionLabel={(fruit) => fruit?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      style={{ margin: 0 }}
                      {...params}
                      label={t('receipts.filters.species')}
                      margin="normal"
                    />
                  )}
                  onChange={(event, newValue) => {
                    const e = {
                      autocomplete: true,
                      input: 'fruitId',
                      value: newValue ? newValue.id : '',
                    };
                    if (falsy(newValue)) {
                      if (truthty(controls.varietyId)) {
                        changeControls({
                          autocomplete: true,
                          input: 'varietyId',
                          value: '',
                        });
                      }
                      if (truthty(controls.productId)) {
                        changeControls({
                          autocomplete: true,
                          input: 'productId',
                          value: '',
                        });
                      }
                    }
                    changeControls(e);
                  }}
                />
                {truthty(invalidControls.fruitId) && (
                  <FormHelperText error>{t('receipts.form.errors.species')}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  value={
                    controls.varietyId &&
                    varietiesOptions.find((variety) => variety.id === controls.varietyId)
                  }
                  id="autocomplete-variety-receipts"
                  options={varietiesOptions}
                  getOptionLabel={(variety) => variety?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      style={{ margin: 0 }}
                      {...params}
                      label={t('receipts.filters.variety')}
                      margin="normal"
                    />
                  )}
                  disabled={falsy(controls.fruitId)}
                  onChange={(event, newValue) => {
                    const e = {
                      autocomplete: true,
                      input: 'varietyId',
                      value: newValue ? newValue.id : '',
                    };
                    if (truthty(newValue)) {
                      if (truthty(controls.productId)) {
                        const product = objects.products[controls.productId];
                        if (product.varietyId !== newValue.id) {
                          changeControls({
                            autocomplete: true,
                            input: 'productId',
                            value: '',
                          });
                        }
                      }
                    } else if (truthty(controls.productId)) {
                      changeControls({
                        autocomplete: true,
                        input: 'productId',
                        value: '',
                      });
                    }
                    changeControls(e);
                  }}
                />
                {truthty(invalidControls.varietyId) && (
                  <FormHelperText error>{t('receipts.form.errors.variety')}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  value={
                    controls.productId &&
                    productsOptionsFiltered.find((product) => product.id === controls.productId)
                  }
                  id="autocomplete-product-receipts"
                  options={productsOptionsFiltered}
                  getOptionLabel={(product) => product?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      style={{ margin: 0 }}
                      {...params}
                      label={t('receipts.headers.product')}
                      margin="normal"
                    />
                  )}
                  disabled={falsy(controls.fruitId)}
                  onChange={(event, newValue) => {
                    const e = {
                      autocomplete: true,
                      input: 'productId',
                      value: newValue ? newValue.id : '',
                    };
                    changeControls(e);
                  }}
                />
                {truthty(invalidControls.productId) && (
                  <FormHelperText error>{t('receipts.form.errors.product')}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <Typography gutterBottom variant="h6" component="h6">
                  {t('receipts.form.packaging')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel id="warehouse-label">{t('receipts.form.warehouse')}</InputLabel>
                  <Select
                    labelId="warehouse-label"
                    fullWidth
                    value={controls.warehouseId}
                    onChange={changeControls}
                    error={invalidControls.warehouseId}
                    disabled={packagingReadOnly}>
                    <MenuItem id="warehouseId" value="">
                      {t('receipts.form.none')}
                    </MenuItem>
                    {Object.values(objects.warehouses)
                      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
                      .map((warehouse) => (
                        <MenuItem
                          key={`warehouse-option-${warehouse.id}`}
                          id="warehouseId"
                          value={warehouse.id}>
                          {warehouse.name}
                        </MenuItem>
                      ))}
                  </Select>
                  {truthty(invalidControls.warehouseId) && (
                    <FormHelperText error>{t('receipts.form.errors.warehouse')}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  value={
                    controls.packagingTypeId &&
                    packagingTypesOptions.find(
                      (packagingType) => packagingType.id === controls.packagingTypeId,
                    )
                  }
                  id="autocomplete-packagingType-receipts"
                  options={packagingTypesOptions}
                  getOptionLabel={(packagingType) => packagingType?.name || ''}
                  renderInput={(params) => (
                    <TextField
                      style={{ margin: 0 }}
                      {...params}
                      label={t('receipts.form.container')}
                      margin="normal"
                    />
                  )}
                  onChange={(event, newValue) => {
                    const e = {
                      autocomplete: true,
                      input: 'packagingTypeId',
                      value: newValue ? newValue.id : '',
                    };
                    changeControls(e);
                  }}
                  disabled={packagingReadOnly}
                />
                {truthty(invalidControls.packagingTypeId) && (
                  <FormHelperText error>{t('receipts.form.errors.packagingType')}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <WeightField
                  quantity={controls.quantity}
                  changeWeight={changeWeight}
                  changeControls={changeControls}
                  error={invalidControls.quantity}
                  helperText={
                    invalidControls.quantity &&
                    t('receipts.form.errors.quantity', { unit: unitCode })
                  }
                  totalWeight={totalWeight}
                  label={unitCode}
                  disabled={packagingReadOnly}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  value={controls.packagingQuantity}
                  onChange={changeControls}
                  fullWidth
                  id="packagingQuantity"
                  label={t('receipts.form.containerQuantity')}
                  error={invalidControls.packagingQuantity}
                  disabled={packagingReadOnly}
                  helperText={
                    invalidControls.packagingQuantity && t('receipts.form.errors.packagingQuantity')
                  }
                />
              </Grid>
              <Grid item container justifyContent="flex-end">
                <Grid item xs={12} sm={6} md={4}>
                  <Button
                    onClick={
                      canApplyAutomationReclassification
                        ? handleAutomationFlowAction
                        : handleManualFlowAction
                    }
                    color="primary"
                    variant="outlined"
                    fullWidth
                    disabled={
                      controls.addLotsloading ||
                      (!hasAutomation && hasLotsInAnotherProcess) ||
                      (canApplyAutomationReclassification && !hasReclassificationChanges)
                    }>
                    {canApplyAutomationReclassification
                      ? 'APLICAR CAMBIOS'
                      : t('receipts.form.add')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                {truthty(invalidControls.lots) && (
                  <FormHelperText error>{t('receipts.form.errors.minPak')}</FormHelperText>
                )}
                {hasAutomation && shouldPrintFourAutomationLabelsPerPak() && (
                  <FormHelperText>
                    {t('receipts.form.automationCopiesHint')}
                  </FormHelperText>
                )}
                {usesBulkPackaging && (
                  <FormHelperText>
                    {'Para tolva/granel se genera un solo PAK por defecto; el peso define kilos, no cantidad de etiquetas.'}
                  </FormHelperText>
                )}
                {canApplyAutomationReclassification && (
                  <FormHelperText>
                    {
                      'Los PAKs ya están en otro proceso. Puedes cambiar especie/variedad/producto y aplicar cambios; no se crearán nuevos PAKs.'
                    }
                  </FormHelperText>
                )}
              </Grid>
            </>
          )}
        </Grid>
        {controls.receiptId && (
          <Grid item container xs={12} spacing={1}>
            <Grid item xs={12}>
              <Typography gutterBottom variant="h6" component="h6">
                {t('receipts.form.receivedPaks')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Paper style={{ padding: 30, margin: 10 }}>
                <List dense>
                  {objects.receipts[controls.receiptId].lots().map((l, index) => (
                    <LotListItem
                      key={`receipt-lot-${l.id}`}
                      lot={l}
                      objects={objects}
                      index={index}
                      product={objects.products[l.productId]}
                      classes={classes}
                      addToReturnLots={addToReturnLots}
                      printFnc={printLotFnc}
                      deleteFnc={() => toggleDeleteLot(l.id)}
                    />
                  ))}
                </List>
              </Paper>
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogContent />
      <DialogActions>
        <Button onClick={toggleForm} color="primary" variant="outlined">
          {t('receipts.form.close')}
        </Button>
        {!controls.receiptId && (
          <ButtonWithLoader
            onClick={() => submit(newLotNumber, totalWeight)}
            autoFocus
            buttonId="create-edit-receipt">
            {t('receipts.form.create')}
          </ButtonWithLoader>
        )}
      </DialogActions>
    </Dialog>
  );
}

const withSaga = connectSaga({ key: 'sagaReceipts', saga });

const withConnect = connect(
  selectState(
    'receipts.editReceiptData',
    'receipts.invalidControls',
    'receipts.lastLotNumber',
    'receipts.formControls',
    'receipts.formIsOpen',
    'receipts.toEditId',
    'receipts.edit',
    'app.objects',
    'app.device',
    'app.permissions',
  ),
  actionProps(clone(clone.OBJECT, receiptsActions, appActions)),
);

export default compose(withConnect)(React.memo(withSaga(ReceiptForm)));
